/* eslint no-restricted-globals: 0 */
const FormatTime = (seconds, isSingleLeadingZero = true) => {
  const isSecondsValid = seconds && !isNaN(seconds);
  const displaySeconds = isSecondsValid
    ? Math.floor(seconds)
    : 0;

  const formattedTime = new Date(displaySeconds * 1000).toISOString().substr(14, 5);
  const hasLeadingZero = formattedTime[0] === '0';
  const timeWithOneLeadingZero = hasLeadingZero ? formattedTime.substr(1) : formattedTime;

  return isSingleLeadingZero ? timeWithOneLeadingZero : formattedTime;
};

export default FormatTime;
